import React from "react";
import { Loader2 } from "lucide-react";

import { GhostButton } from "@/shared/components/settings-atoms";
import usePublish from "./hooks/usePublish";
import usePublishFlow from "./hooks/usePublishFlow";

import type { Agent } from "@/shared/types";

/* Tucked on top of the chat composer while the agent's draft differs from its published
   version. Chats run the published one, so a change being tried here is not in them
   until Publish. Publish here is the Settings one: evals first when the agent asks. */
export default function UnpublishedNote({ agent }: { agent: Agent }) {
  const { changed } = usePublish(agent);
  return changed ? <Note agent={agent} /> : null;
}

function Note({ agent }: { agent: Agent }) {
  const { start, publishing, gated, dialog } = usePublishFlow(agent);
  return (
    <div className="mx-6 sm:mx-9 -mb-3 pb-3 rounded-t-[14px] ring-1 ring-[var(--warn-ring)] bg-[var(--warn-bg)] fade-in">
      <div role="status" className="h-10 flex items-center gap-2 pl-3 pr-1 text-[12px] whitespace-nowrap text-[var(--warn-text)]">
        <span className="shrink-0 w-1.5 h-1.5 rounded-full bg-[var(--warn)]" />
        <span className="flex-1">
          Unpublished changes
          <span className="hidden sm:inline"> · chats still run <span className="font-mono tabular-nums">{agent.version}</span></span>
        </span>
        <GhostButton onClick={start} disabled={publishing} title={gated ? "Its eval cases run on the draft first" : "Publish the draft as the version chats use"}>
          {publishing ? <><Loader2 className="w-3 h-3 animate-spin" strokeWidth={2.25} />Publishing</> : "Publish"}
        </GhostButton>
      </div>
      {dialog}
    </div>
  );
}
